import { prefixClassname } from "./prefix"

export const HAIRLINE_BORDER = prefixClassname("hairline")
export const HAIRLINE_BORDER_TOP = `${HAIRLINE_BORDER}--top`
export const HAIRLINE_BORDER_LEFT = `${HAIRLINE_BORDER}--left`
export const HAIRLINE_BORDER_BOTTOM = `${HAIRLINE_BORDER}--bottom`
export const HAIRLINE_BORDER_SURROUND = `${HAIRLINE_BORDER}--surround`
export const HAIRLINE_BORDER_TOP_BOTTOM = `${HAIRLINE_BORDER}--top-bottom`
export const HAIRLINE_BORDER_UNSET_TOP_BOTTOM = `${HAIRLINE_BORDER}-unset--top-bottom`
